import { Component } from '@angular/core';

@Component({
  selector: 'app-public-tag',
  standalone: true,
  template: `
    <div
      class="text-secondary-500 inline-block rounded-full bg-yellow-300 px-2 font-bold"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class PublicTagComponent {}
